import { render, staticRenderFns } from "./LanguageTickets.vue?vue&type=template&id=62b5d36f&"
import script from "./LanguageTickets.vue?vue&type=script&lang=js&"
export * from "./LanguageTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports